import React from 'react';
import './NavBar.css';

import instagram from "../../assets/socialmedia/instagram.png";
import facebook from "../../assets/socialmedia/facebook.png";
import spotify from "../../assets/socialmedia/spotify.png";
import youtube from "../../assets/socialmedia/youtube.png";
import applemusic from "../../assets/socialmedia/applemusic.png";
import whatsapp from "../../assets/socialmedia/whatsapp.png";




export const NavBarMobile = () => {
	return (
		<nav className="nav-bar-container-mobile">

			<div className="col-sm-12">
				<div className="row">
				</div>
				{/*<div className="row">*/}
				<div className='nav-link-container-mobile'>
					<a className='nav-bar-link-mobile nav-icon-mobile' href="https://www.instagram.com/mondwild/" rel="noreferrer"
						target="_blank"><img className='instagram' src={instagram} alt="instagram" /></a>
					{/* <a className='nav-bar-link-mobile nav-icon' href="https://www.facebook.com/phiablu/" rel="noreferrer"
					   target="_blank"><img  className='facebook' src={facebook} alt="facebook"/></a> */}
					<a className='nav-bar-link-mobile nav-icon-mobile' href="https://open.spotify.com/artist/6s96d678Hgy10yUb32I0GT" rel="noreferrer"
						target="_blank"><img className='spotify' src={spotify} alt="spotify" /></a>
					<a className='nav-bar-link-mobile nav-icon-mobile' href="https://www.youtube.com/@mondwild" rel="noreferrer"
						target="_blank"><img className='youtube' src={youtube} alt="youtube" /></a>
					{/* <a className='nav-bar-link-mobile nav-icon' href="https://music.apple.com/de/artist/mondwild/1870810851" rel="noreferrer"
					   target="_blank"><img className='applemusic' src={applemusic}
											alt="applemusic"/></a> */}


				</div>
			</div>
		</nav>
	)
}